/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { InfoResult } from '../models/info-result';

@Injectable({
  providedIn: 'root',
})
export class InfoService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation infoGet
   */
  static readonly InfoGetPath = '/api/Info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infoGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  infoGet$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<InfoResult>> {

    const rb = new RequestBuilder(this.rootUrl, InfoService.InfoGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InfoResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `infoGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infoGet$Plain(params?: {
  },
  context?: HttpContext

): Observable<InfoResult> {

    return this.infoGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<InfoResult>) => r.body as InfoResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  infoGet$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<InfoResult>> {

    const rb = new RequestBuilder(this.rootUrl, InfoService.InfoGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InfoResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `infoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infoGet(params?: {
  },
  context?: HttpContext

): Observable<InfoResult> {

    return this.infoGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<InfoResult>) => r.body as InfoResult)
    );
  }

}
